<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT ParaOverride-1" id="_idParaDest-2"> </p>
<p class="AdCard01">Also by Joyce Carol Oates</p>
<p class="AdCardTitles">The Barrens</p>
<p class="AdCardTitles">Beasts</p>
<p class="AdCardTitles">Rape: A Love Story</p>
<p class="AdCardTitles">The Female of the Species: Tales of Mystery and Suspense</p>
<p class="AdCardTitles">The Museum of Dr. Moses</p>
<p class="AdCardTitles">A Fair Maiden</p>
<p class="AdCardTitles">Give Me Your Heart: Tales of Mystery and Suspense</p>
<p class="AdCardTitles">The Corn Maiden and Other Nightmares</p>
<p class="AdCardTitles">Daddy Love</p>
<p class="AdCardTitles">Evil Eye: Four Novellas of Love Gone Wrong</p>
<p class="AdCardTitles">High Crime Area: Tales of Darkness and Dread </p>
<p class="AdCardTitles">Jack of Spades: A Tale of Suspense</p>
<p class="AdCardTitles">The Doll-Master and Other Tales of Terror</p>
<p class="AdCardTitles">DIS MEM BER and Other Stories of Mystery and Suspense </p>
<p class="AdCardTitles">Night-Gaunts and Other Tales of Suspense</p>
<p class="AdCardTitles">Pursuit</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802158017-1.vue?2d0d56ed